import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {CommonOptions, ModelDocumentsShow, PersonalBlackList} from 'src/app/core/interfaces/interfaces';
import {SnackBarService} from 'src/app/core/services/utils/snackBar.service';
import {environment} from '../../../../../environments/environment';
import {FechasService} from '../../../services/utils/fechas.service';
import {ContratingService} from '../../../services/modules/contrating.service';
import {DocsJsonUtils} from '../../../utils/DocsJsonUtils';
import {CommonService} from '../../../services/modules/common.service';
import {forkJoin} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {AuthGuardService} from '../../../services/guards/AuthGuardService';

export interface DialogData {
  textClose: string;
  textConfirm: string;
  documentType: string;
  documentNumber: string;
  companyInfoId: string;
  employers: any[];
  mode: 'SANCTION' | 'VETO';
}

@Component({
  selector: 'app-dialog-selected-causal',
  templateUrl: './dialog-selected-causal.component.html',
  styleUrls: ['./dialog-selected-causal.component.scss']
})
export class DialogSelectedCausalComponent implements OnInit {
  s3Bucket: string;
  commentary = '';
  formVigencia: FormGroup;
  endDateBlackList: string;
  isAdminUser = false;
  flagBlackList = false;
  personalBlackListId = '0';
  flagDisableAllForm = false;
  flagBlackListFuture = false;

  maxSanctionDays: number | null = null;
  maxFinishDateAllowed: string | null = null;

  files: File[] = [];
  datasource: any[] = [];
  infoHistory: any[] = [];
  allEmployers: any[] = [];
  causalesData: CommonOptions[] = [];

  controlSelected = new FormControl();
  employerControl = new FormControl();
  dateNowStart = this.fechasService.getDateTimeNow();
  minDateNowFinish = this.fechasService.getDateTimeNow();
  minDateNowStart = this.fechasService.getDateTimeNow();
  dateNowFinish = this.fechasService.getDateTimeNow(true);

  constructor(
    public dialogRef: MatDialogRef<DialogSelectedCausalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private snackBService: SnackBarService,
    private fb: FormBuilder,
    private authService: AuthGuardService,
    private fechasService: FechasService,
    private contractingService: ContratingService,
    private commonService: CommonService,
  ) {
    this.formVigencia = this.fb.group({
      StartDate: '',
      FinishDate: ''
    });
    this.getEmployerAll();
   }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;

    if (this.data.mode === 'SANCTION') {
      this.contractingService.getBlacklistPersonalPolicy(this.data.companyInfoId)
        .subscribe((policy: any) => {
          this.maxSanctionDays = policy?.MaxSanctionDurationDays ?? null;
          this.updateMaxFinishDate();
        });
    }
    this.isAdminUser = this.authService.auth.getUser().IsAdmin;

    forkJoin({
      causales: this.commonService.getCommonOptions('BlacklistReason')
    }).pipe(
      switchMap(({causales }) => {
        this.causalesData = causales.sort((a, b) => a.OrderNum - b.OrderNum);

        const targetValue = this.data.mode === 'VETO' ? 'VETOS' : 'SANCIONES';
        this.datasource = this.causalesData.filter(x => (x.Value || '').toUpperCase() === targetValue);

        if (this.datasource.length === 0) {
          this.datasource = [];
        }

        this.controlSelected.setValue(this.datasource[0]?.Id ?? null);

        return this.contractingService.getHistoricalBlackList(
          this.data.documentType,
          this.data.documentNumber
        );
      }),
      switchMap((data: any) => {
        this.infoHistory = data
          .sort((a: any, b: any) => new Date(b.UpdateDate).getTime() - new Date(a.UpdateDate).getTime())
          .map((item: any) => {
            const parsedDocs = DocsJsonUtils.deserializeDocsJSON(item.DocsJSON);
            return {
              ...item,
              DocsJSONParsed: parsedDocs ? parsedDocs['DOC-1'] : null
            };
          });

        const api$ = this.data.mode === 'VETO'
          ? this.contractingService.getPersonalBlackListInfoVetos(
            this.data.documentType,
            this.data.documentNumber,
            this.data.companyInfoId
          )
          : this.contractingService.getPersonalBlackListInfoSanction(
            this.data.documentType,
            this.data.documentNumber,
            this.data.companyInfoId
          );

        return api$;
      })
    ).subscribe((rest: any) => {
      this.flagBlackList = rest.BlackList;
      this.flagBlackListFuture = rest.FutureBlackList;

      if (this.flagBlackList || this.flagBlackListFuture) {
        if (this.flagBlackList && !this.flagBlackListFuture) {
          this.minDateNowStart = rest.StartDate;
        }

        this.dateNowStart = rest.StartDate;
        this.formVigencia.get('StartDate').setValue(rest.StartDate);
        this.minDateNowFinish = this.fechasService.getDateTimeNow();

        if (rest.EndDate != null) {
          this.endDateBlackList = rest.EndDate;
          this.dateNowFinish = rest.EndDate;
          this.formVigencia.get('FinishDate').setValue(rest.EndDate);
        } else {
          const now = this.fechasService.getDateTimeNow(true);
          this.endDateBlackList = now;
          this.dateNowFinish = now;
          this.formVigencia.get('FinishDate').setValue(now);
        }

        this.personalBlackListId = rest.Id;
        this.employerControl.setValue(rest.EmployerId);

        if (
          this.employerControl.value === null ||
          this.employerControl.value === '00000000-0000-0000-0000-000000000000'
        ) {
          this.employerControl.setValue(this.allEmployers[0].Id);
        }

        const reason = this.causalesData.find(item => item.Id === rest.ReasonId);
        this.controlSelected.setValue(rest.ReasonId);
        this.updateMaxFinishDate();
      }
    });
  }



  private toInputDateTimeValue(d: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  private updateMaxFinishDate(): void {
    if (!this.maxSanctionDays || this.data.mode !== 'SANCTION') {
      this.maxFinishDateAllowed = null;
      return;
    }

    const ctrl = this.formVigencia.get('StartDate');
    const startStr = ctrl && ctrl.value ? ctrl.value : this.dateNowStart;

    if (!startStr) {
      this.maxFinishDateAllowed = null;
      return;
    }

    const start = new Date(startStr);
    const max = new Date(start);
    max.setDate(max.getDate() + this.maxSanctionDays);

    this.maxFinishDateAllowed = this.toInputDateTimeValue(max);
  }

  getEmployerAll() {
      this.commonService.getAllEmployersCompanyId(this.data.companyInfoId).subscribe((data: any) => {
        this.allEmployers = data
          .filter((employer: any) => this.data.employers.includes(employer.Id))
          .sort((a, b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0));
      });
  }

  close() {
    this.dialogRef.close(false);
  }

  async save() {
    this.setDefaultDates();

    const startDatePlus = new Date(this.formVigencia.get('StartDate').value);
    startDatePlus.setMinutes(startDatePlus.getMinutes() + 5);
    const now = new Date(this.fechasService.getDateTimeNow());
    const startDate = new Date(this.formVigencia.get('StartDate').value);
    const finishDate = new Date(this.formVigencia.get('FinishDate').value);

    if (!this.controlSelected.value) {
      this.snackBService.openWarning('Debes seleccionar alguna opción para continuar.', '', 4000);
      return;
    }
    if (this.employerControl.value === null || this.employerControl.value === '00000000-0000-0000-0000-000000000000') {
      this.snackBService.openWarning('Debes seleccionar un empleador.', '', 4000);
      return;
    }
    if (this.flagBlackList === false) {
      if (startDatePlus < now) {
        this.snackBService.openWarning('La fecha de inicio no puede ser menor a la fecha actual.', '', 4000);
        return;
      }
    }
    if (finishDate < startDate) {
      this.snackBService.openWarning('La fecha de fin no puede ser menor a la fecha de inicio.', '', 4000);
      return;
    }

    if (this.data.mode === 'SANCTION' && this.maxSanctionDays) {
      const diffMs = finishDate.getTime() - startDate.getTime();
      const diffDays = diffMs / (1000 * 60 * 60 * 24);

      if (diffDays > this.maxSanctionDays) {this.snackBService.openWarning(
          `El máximo de días a sancionar configurado es ${this.maxSanctionDays}.`, '', 4000);
                                            return;
      }
    }

    const formData = this.createFormData();
    const personalBlack: PersonalBlackList = this.createPersonalBlackList();

    try {
      if (this.data.mode === 'SANCTION' && this.maxSanctionDays != null) {
        const policyModel = {
          MaxSanctionDays: this.maxSanctionDays,
          CompanyInfoId: this.data.companyInfoId
        };
        await this.contractingService.postBlacklistPersonalPolicy(policyModel).toPromise();
      }

      if (this.flagBlackList === true || this.flagBlackListFuture === true) {
        if (this.formVigencia.get('FinishDate').value < this.fechasService.getDateTimeNow()) {
          this.snackBService.openWarning('La fecha de finalización no puede ser menor a la fecha actual.', '', 4000);
          return;
        }
        if (this.endDateBlackList > this.fechasService.getDateTimeNow()) {
          const responseBlackList: any = await this.contractingService
            .putPersonalBlackList(this.personalBlackListId, personalBlack)
            .toPromise();
          if (formData) {
            await this.contractingService.putPersonalBlackListFile(responseBlackList.Id, formData).toPromise();
          }
        }
      } else {
        let responseBlackList: any;
        if (this.data.mode === 'VETO') {
          responseBlackList = await this.contractingService.postPersonalBlackListVeto(personalBlack).toPromise();
        } else {
          responseBlackList = await this.contractingService.postPersonalBlackListSanction(personalBlack).toPromise();
        }
        if (formData) {
          await this.contractingService.putPersonalBlackListFile(responseBlackList.Id, formData).toPromise();
        }
      }

      this.dialogRef.close(true);
    } catch (error) {
    }
  }

  private createFormData(): FormData | null {
    if (this.files.length === 0) { return null; }

    const formData = new FormData();
    this.files.forEach(item => formData.append('File', item));
    return formData;
  }

  private setDefaultDates(): void {
    if (!this.formVigencia.get('StartDate').value) {
      this.formVigencia.get('StartDate').setValue(this.fechasService.getDateTimeNow());
    }
    if (!this.formVigencia.get('FinishDate').value) {
      this.formVigencia.get('FinishDate').setValue(this.fechasService.getDateTimeNow(true));
    }
  }

  private createPersonalBlackList(): PersonalBlackList {
    return {
      CompanyInfoId: this.data.companyInfoId,
      DocumentType: this.data.documentType,
      DocumentNumber: this.data.documentNumber,
      StartDate: this.formVigencia.get('StartDate').value,
      EndDate: this.formVigencia.get('FinishDate').value,
      ReasonId: this.controlSelected.value,
      Observation: this.commentary,
      EmployerId: this.employerControl.value
    };
  }

  onSelectedAllEmployer(id) {
    this.employerControl.setValue(id);
  }

  selected(e) {
    //    this.dialogRef.close(e);
  }

  changeDate(date: string, isFinishDate: boolean) {
    if (!date) { return; }

    const startCtrl = this.formVigencia.get('StartDate');
    const finishCtrl = this.formVigencia.get('FinishDate');

    if (!startCtrl || !finishCtrl) { return; }

    if (isFinishDate) {
      finishCtrl.setValue(date);
      this.dateNowFinish = date;

      if (this.data.mode === 'SANCTION' && this.maxSanctionDays) {
        const startValue = startCtrl.value ? startCtrl.value : this.dateNowStart;
        const start = new Date(startValue);
        const finish = new Date(date);

        const diffMs = finish.getTime() - start.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        if (diffDays > this.maxSanctionDays) {
          const max = new Date(start);
          max.setDate(max.getDate() + this.maxSanctionDays);
          const corrected = this.toInputDateTimeValue(max);

          finishCtrl.setValue(corrected);
          this.dateNowFinish = corrected;
          this.snackBService.openWarning(`El máximo de días a sancionar es ${this.maxSanctionDays}.`, '', 4000);
        }
      }

    } else {
      startCtrl.setValue(date);
      this.dateNowStart = date;
      this.updateMaxFinishDate();
    }
  }

  onSelect(event: any) {
    const selectedFiles: FileList = event.addedFiles;
    if (selectedFiles.length > 0) {
      this.files = [selectedFiles[0]];
    }
  }

  removeFile(index) {
    this.files.splice(index, 1);
  }

  openImgVideo(doc) {
    window.open(this.s3Bucket + doc, '_blank');
  }

  isXLSX(doc: any): boolean {
    return this.getUrl(doc).slice(-5).toUpperCase() === '.XLSX';
  }

  getUrl(doc: ModelDocumentsShow): string {
    let url = '';
    const a = doc?.urlDoc?.split('||name=');
    if (a !== undefined) {
      url = a[0];
    }
    return url;
  }

  getUrlFile(url) {
    return this.s3Bucket + url;
  }

  getDateFormatDateYYYYMMDD(date): string {
    let response = '';
    if (date !== null) {
      response = this.fechasService.formatDateYYYYMMDD24Hours(date);
    }
    return response;
  }

  getDescriptionDoc(description: string): string{
    if (description === null || description === '' || description === undefined){
      return 'Actualizado';
    }
    if (description === 'Agregado'){
      return 'Creado';
    }
    return description;
  }

  getDescriptionById(reasonId: number): string {
    const reason = this.datasource.find(item => item.Id === reasonId);
    return reason ? reason.Description : 'No encontrado';
  }

  getEmployerNameById(employerId: number): string {
    const employer = this.allEmployers.find(item => item.Id === employerId);
    return employer ? employer.Name : 'No encontrado';
  }

  disableStartDate(): boolean {
    if (this.flagBlackList === true){
      return this.minDateNowStart <= this.fechasService.getDateTimeNow();
    }else{
      return false;
    }
  }

  disableAllForm() {
    this.flagDisableAllForm = true;
  }
}
